import { Form } from "react-bootstrap";
import { CloseSvg } from "../../CommonComponents/svgs/Svgs";
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage, onKeyDown, showToastMessage, truncateNumber } from "../../../utils/commonFunctions";
import { checkNumberInputValidation, downloadJSON, getLoadingButtonText, getNewBusData, validateBusForm } from "../utils";
import { useDispatch, useSelector } from "react-redux";
import CustomToolTip from "../../CommonComponents/CustomToolTip";
import { isEmpty } from "lodash";
import CatalogueService from "../../../service/CatalogueService";
import { setCloneTemplate } from "../../../store/CatalogSlice";
import { BusFormDataType } from "../Catalogs";
import { BASIC_BUS_DATA_FIELDS } from "../utils/constants";

interface CreateBusBasicsProps {
    mode: "Create" | "Update" | "Clone" | null;
    componentType: string;
    editedTemplateData: any;
    setOpenConfirmationDialog: React.Dispatch<React.SetStateAction<boolean>>;
    setOpenConfigurationModal: React.Dispatch<React.SetStateAction<"Create" | "Update" | "Clone" | null>>;
    setCreateBusStage: React.Dispatch<React.SetStateAction<'first' | 'second'>>;
    busData: BusFormDataType;
    setBusData: React.Dispatch<React.SetStateAction<BusFormDataType>>;
    blankTemplateData: { [key: string]: any };
    setRefreshCatalog: () => void
    modalLoader: boolean
    setModalLoader: React.Dispatch<React.SetStateAction<boolean>>
}

const CreateBusBasics = ({
    mode,
    busData,
    setBusData,
    componentType,
    setOpenConfigurationModal,
    editedTemplateData,
    setCreateBusStage,
    blankTemplateData,
    setRefreshCatalog,
    setOpenConfirmationDialog,
    modalLoader,
    setModalLoader
}: CreateBusBasicsProps) => {

    const dispatch = useDispatch();
    const userData = useSelector((state: any) => state.mission.userData);
    const CloneTemplate = useSelector((state: any) => state.catalog.CloneTemplate);

    const { name, size, maxPower, maxMass, maxPayloadSize, maxPayloadPower, maxPayloadMass, inertia, simulationParameters } = busData;
    const { breadth, width, height } = size


    const handleNamechange = (name: string, value: string) => {
        const max_length = 26;
        if (containsSpecialChars(value)) {
            const message = getSpecialCharacterMessage()
            showToastMessage('info', message)
        } else if (value.length > max_length) {
            const message = getCharacterLimitMessage(max_length)
            showToastMessage('info', message)
        } else {
            setBusData((prev) => ({ ...prev, [name]: value }));
        }
    }

    const updateField = (isNested: boolean, field: string, value: any, max_length: number, parentKey?: string) => {
        if (!checkNumberInputValidation(value, max_length)) return;
        if (!isNested) {
            setBusData((prev) => ({ ...prev, [field]: value }));
        } else if (isNested && parentKey) {
            setBusData((prev) => ({
                ...prev, [parentKey]: { ...prev[parentKey], [field]: value }
            }));
        }
    };

    const handleJsonUpload = (e: any) => {
        const inputElement = document.createElement('input');
        inputElement.type = 'file';
        inputElement.accept = '.json';
        inputElement.onchange = (event: any) => {
            const file = event.target.files[0];
            if (file && file.type === 'application/json') {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    const uploadFile = e.target.result;
                    setBusData((prev) => ({
                        ...prev,
                        simulationParameters: {
                            name: file.name,
                            data: uploadFile
                        }
                    }))
                };
                reader.readAsText(file);
            } else {
                showToastMessage('error', "Invalid file format");
            }
        }
        inputElement.click();
    }

    const handleJsonDownload = () => {
        const data = blankTemplateData?.['assembly']?.[0]?.['iADCS']?.['atmos-data']?.['adcs_config']
        const name = `Sample_simulation_parameters.json`
        downloadJSON(data, name)
    }
    const goPrevious = () => {
        setCreateBusStage("first")
    }

    const saveBus = async () => {
        const updated_mode = mode === 'Create' ? 'creat' : 'updat'
        const validate = validateBusForm(busData)
        if (!validate) return
        const data = getNewBusData(blankTemplateData, CloneTemplate, busData, userData)
        setModalLoader(true)
        try {
            if (mode === 'Create') {
                await CatalogueService.postTemplate(data)
            } else {
                await CatalogueService.updateTemplate(editedTemplateData?.['uniqueId'], data)
            }
            setRefreshCatalog();
            showToastMessage('success', `Bus Design ${updated_mode}ed successfully`)
            dispatch(setCloneTemplate({}))
        } catch (error: any) {
            const message = typeof error?.response?.data === 'string' ? error?.response?.data : error?.response?.data?.message || `Something went wrong while ${updated_mode}ing new bus design`;
            showToastMessage('error', message)
            setOpenConfigurationModal(null);
            setModalLoader(false);
        }
    }


    return (
        <div className="create-payload d-flex flex-column justify-self-center gap-3 h-auto">
            <div className="cp-header">
                <div className="cp-header-title">
                    {componentType} Details
                </div>
                <div onClick={() => setOpenConfirmationDialog(true)}>
                    <CloseSvg />
                </div>
            </div>
            <div className="modal__separator" />
            <div className="cp-body">
                <div className="w-100 d-flex flex-row align-items-center gap-2">
                    <div className="w-50 d-flex flex-column">
                        <span className="cp-text">Name </span>
                        <Form.Control type="text" className="form-control"
                            placeholder="Name"
                            value={name}
                            onChange={(e) => {
                                const inputValue = e.target.value.trimStart();
                                handleNamechange('name', inputValue);
                            }}
                        />
                    </div>
                    <div className="d-flex flex-column flex-1 position-relative">
                        <span className="cp-text">Simulation Parameter</span>
                        <div className="form-control w-100 p-2 fs-14 d-flex align-items-center justify-content-center">
                            {simulationParameters &&
                                <div className="w-100 h-100 d-flex gap-2">
                                    <div className="w-10 d-flex align-content-center justify-content-center border-right"><i className="fe fe-file-text mt-1" /></div>
                                    <div className="flex-1 d-flex align-items-center">
                                        <span className="px-1 flex-1 text-truncate">{simulationParameters?.name}</span>
                                    </div>
                                    <button className="d-flex align-items-center h-auto p-0 justify-content-center bg-transparent border-0 border-left w-10"
                                        onClick={() => {
                                            setBusData((prev) => ({
                                                ...prev,
                                                simulationParameters: null
                                            }))
                                        }}
                                    >
                                        <i className="fe fe-x"></i>
                                    </button>
                                </div>
                            }
                            {!simulationParameters &&
                                <button className="border-0 w-100 h-auto p-0 bg-transparent fs-14 opacity-75"
                                    onClick={handleJsonUpload}
                                >
                                    Choose File
                                </button>
                            }
                        </div>

                        {!isEmpty(blankTemplateData) &&
                            <div className="position-absolute right-0 top-0">
                                <CustomToolTip title="Sample File">
                                    <button className="bg-transparent w-auto h-auto p-0 opacity-75"
                                        onClick={handleJsonDownload}
                                    >
                                        <i className="fe fe-download"></i>
                                    </button>
                                </CustomToolTip>
                            </div>
                        }
                    </div>
                </div>

                <div className="w-100 d-flex flex-row gap-2 justify-content-between">
                    <div className="d-flex flex-column flex-1">
                        <span className="cp-text">Max Power (W)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter power"
                            value={maxPower}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                updateField(false, 'maxPower', event.target.value, 5);
                            }}
                        />
                    </div>

                    <div className="d-flex flex-column flex-1">
                        <span className="cp-text">Max Mass (kg)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter mass"
                            value={maxMass}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                updateField(false, 'maxMass', event.target.value, 5);
                            }}
                        />
                    </div>
                </div>


                <div className="w-100 d-flex flex-row gap-2 justify-content-between">
                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Height (m)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter size"
                            value={height}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                updateField(true, 'height', event.target.value, 5, 'size');
                            }}
                        />
                    </div>
                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Width (m)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter size"
                            value={width}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                updateField(true, 'width', event.target.value, 5, 'size');
                            }}
                        />
                    </div>
                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Breadth (m)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter size"
                            value={breadth}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                updateField(true, 'breadth', event.target.value, 5, 'size');
                            }}
                        />
                    </div>
                </div>

                <div className="w-100 d-flex flex-row gap-2 justify-content-between mt-3">
                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Max Payload Size (U)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter payload size"
                            value={maxPayloadSize}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                const height = Number(busData?.size?.height) || 0
                                const width = Number(busData?.size?.width) || 0
                                const breadth = Number(busData?.size?.breadth) || 0
                                const maxSize = truncateNumber(((height * width * breadth) / 100), 1)
                                if (Number(event.target.value) < maxSize) {
                                    updateField(false, 'maxPayloadSize', event.target.value, 5);
                                } else {
                                    showToastMessage("info", "Max payload size should be less than bus size");
                                }
                            }}
                        />
                    </div>

                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Max Payload Power (W)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter payload power"
                            value={maxPayloadPower}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                const maxPower = Number(busData?.maxPower)
                                if (Number(event.target.value) < maxPower) {
                                    updateField(false, 'maxPayloadPower', event.target.value, 5);
                                } else {
                                    showToastMessage("info", "Max payload power should be less than bus power");
                                }
                            }}
                        />
                    </div>

                    <div className="d-flex flex-column flex-fill">
                        <span className="cp-text">Max Payload Mass (kg)</span>
                        <Form.Control
                            type="text"
                            required
                            placeholder="Enter payload mass"
                            value={maxPayloadMass}
                            onKeyDown={onKeyDown}
                            onChange={(event: any) => {
                                const maxMass = Number(busData?.maxMass)
                                if (Number(event.target.value) < maxMass) {
                                    updateField(false, 'maxPayloadMass', event.target.value, 5);
                                } else {
                                    showToastMessage("info", "Max payload mass should be less than bus mass");
                                }
                            }}
                        />
                    </div>
                </div>

                <div className="w-100 d-flex flex-row gap-2 flex-wrap">
                    {inertia && Object.entries(inertia).map(([key, value], index) => {
                        return (
                            <div className="d-flex flex-column" key={index}
                                style={{ flex: '1 0 calc(33.33% - 12px)' }}
                            >
                                <span className="cp-text">{key}</span>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder={`Enter ${key}`}
                                    value={value}
                                    onKeyDown={onKeyDown}
                                    onChange={(event: any) => {
                                        updateField(true, key, event.target.value, 5, 'inertia');
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>

            </div >
            <div className="modal__separator" />
            <div className="cp-footer">
                <button className="btn btn-outline-danger py-1 px-4 fs-14"
                    onClick={() => {
                        setOpenConfirmationDialog(true)
                    }}>
                    Close
                </button>
                <div className="d-flex gap-2 align-items-center">
                    <button className="btn btn-outline-primary py-1 px-6 fs-14"
                        disabled={modalLoader}
                        onClick={goPrevious}>
                        Back
                    </button>
                    <button className="btn btn-primary d-flex align-items-center gap-2 py-1 px-4 fs-14"
                        disabled={modalLoader}
                        onClick={saveBus}>
                        {modalLoader ? getLoadingButtonText(mode) : mode}
                        {modalLoader && <div className='spin__loader' />}
                    </button>
                </div>
            </div>

        </div >
    )
};

export default CreateBusBasics;